import mbgImg from "../../../assets/img/money-back-guarantee.png";
import mbgImgWebp from "../../../assets/img/money-back-guarantee.webp";

const MoneyBackGuaranteeTsl = () => (
    <section id="money-back-guarantee-tsl">
        <div className="container-fluid pb-5">
            <div className="row mt-5 pt-5 justify-content-center align-items-center">
                <div className="col-md-8 col-11 gg-bg-gradient-v-2 gg-border-radius">
                    <div className="row">
                        <div className="col-lg-3 col-12 text-lg-end text-center ms-lg-3 me-lg-4">
                            <picture>
                                <source srcSet={mbgImgWebp} type="image/webp" />
                                <img className="img-fluid gg-mbg-logo" src={mbgImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-lg-8 mt-3 px-lg-0 px-5 pb-3 text-white text-lg-start text-center">
                            <h3>You’re Protected, Always.</h3>
                            <h3 className="mb-5">90-Day Money Back Guarantee</h3>
                            <p>If you’re not thrilled with your results - if your blood sugar doesn’t stabilise, your energy doesn’t rise, or your life doesn’t shift the way you hoped... You get every penny back.</p>
                            <p>We’re not in this to sell bottles.</p>
                            <p>We’re in this to see lives change - even if that means giving you 90 days to decide, while we sit on stock we could be selling.</p>
                            <p className="fw-bold">Because your trust is worth more to us than a transaction.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default MoneyBackGuaranteeTsl;